var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrownRound = function SvgIconCrownRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .9A5.1 5.1 0 1 1 6 11.1 5.1 5.1 0 0 1 6 .9m.3 2.353c-.15-.254-.45-.252-.6 0L4.69 5.538a.21.21 0 0 1-.365.048L2.85 4.16c-.129-.171-.46-.077-.45.139l.801 4.254c.006.118.1.21.214.21h5.152a.217.217 0 0 0 .214-.21L9.6 4.309c.011-.218-.321-.32-.45-.148L7.688 5.586a.21.21 0 0 1-.365-.048z"
  })));
};
export default SvgIconCrownRound;